module.exports = __webpack_public_path__ + "images/favicon.production.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.production.ico
// module id = 1114
// module chunks = 1